import * as actionTypes from "../actionTypes";

export const getInvoicesList = (data) => {
  return {
    type: actionTypes.GET_INVOICES_LIST_START,
    payload: data,
  };
};
export const getInvoicesListSuccess = (data) => {
  return {
    type: actionTypes.GET_INVOICES_LIST_SUCCESS,
    payload: data,
  };
};
export const getInvoicesListFailure = (data) => {
  return {
    type: actionTypes.GET_INVOICES_LIST_FAILURE,
    payload: data,
  };
};
export const getLabelInvoicesList = (data) => {
  return {
    type: actionTypes.GET_LABEL_INVOICES_LIST_START,
    payload: data,
  };
};
export const getLabelInvoicesListSuccess = (data) => {
  return {
    type: actionTypes.GET_LABEL_INVOICES_LIST_SUCCESS,
    payload: data,
  };
};
export const getLabelInvoicesListFailure = (data) => ({
  type: actionTypes.GET_LABEL_INVOICES_LIST_FAILURE,
  payload: data,
});

export const invoicesMessageHandler = () => ({
  type: actionTypes.INVOICES_ERROR_HANDLER,
  payload: null,
});

export const generateInvoiceStart = (data) => ({
  type: actionTypes.GENERATE_INVOICE_START,
  payload: data,
});
export const updateInvoiceStart = (data) => ({
  type: actionTypes.UPDATE_INVOICE_START,
  payload: data,
});
export const rejectedInvoiceHandler = () => ({
  type: actionTypes.REJECTED_INVOICES_HANDLER,
  payload: null,
});
export const generateInvoiceSuccess = (data) => {
  let arr = data.data;
  let rejected = null
  if (arr) {
    if (arr.length > 0) {
      rejected = arr;
    }
  }
  const d = {success: data.message, rejected}
  return {
    type: actionTypes.GENERATE_INVOICE_SUCCESS,
    payload: d,
  };
};

export const getInvoicesReportList = (data) => ({
  type: actionTypes.GET_INVOICES_REPORT_LIST_START,
  payload: data,
});
export const getInvoicesReportListSuccess = (data) => ({
  type: actionTypes.GET_INVOICES_REPORT_LIST_SUCCESS,
  payload: data,
});
export const getInvoicesReportListFailure = (data) => ({
  type: actionTypes.GET_INVOICES_REPORT_LIST_FAILURE,
  payload: data,
});

export const generateInvoiceFailure = (data) => {
  // console.log(data)
  return {
    type: actionTypes.GENERATE_INVOICE_FAILURE,
    payload: {error:data},
  }
};
